import { firebase, disconnectDb } from 'app-modules/application/utils/firebase';
import { SELECT_CHOICE } from './types';
import { triviaAuthenticatedUserIdSelector } from '../selectors/authenticatedUserId';

const checkTriviaQuestion = (triviaState, triviaId, selectedChoice) => {
  const { loadedData, answers } = triviaState;
  if (loadedData === null) {
    throw new Error('Trivia not loaded');
  }

  if (!loadedData.choices.includes(selectedChoice)) {
    throw new Error('Invalid choice');
  }

  if (answers) {
    const triviaAnswered = answers[triviaId];

    if (triviaAnswered) {
      throw new Error('Trivia question already answered');
    }
  }
};

export const triviaSelectChoiceThunkAction = (triviaId, selectedChoice, timeRemaining) => async (
  dispatch,
  getState,
) => {
  try {
    const state = getState();
    const {
      trivia: { isConfigured, ...triviaState },
      device: { ID: deviceID },
    } = state;
    const authenticatedUserId = triviaAuthenticatedUserIdSelector(state);
    if (!isConfigured) {
      throw new Error('Trivia not configured');
    }

    const db = firebase.database();
    const triviaCorrectChoiceSnapshot = await db
      .ref(`/trivias/${triviaId}/correctChoice`)
      .once('value');

    if (triviaCorrectChoiceSnapshot.exists()) {
      checkTriviaQuestion(triviaState, triviaId, selectedChoice);

      const correctChoice = triviaCorrectChoiceSnapshot.val();

      const isCorrect = correctChoice === selectedChoice;

      const {
        loadedData: { points },
      } = triviaState;

      const earnedPoints = isCorrect ? points : 0;

      const payload = {
        earnedPoints,
        isCorrect,
        selectedChoice,
        correctChoice,
        timeRemaining,
        createdAt: firebase.database.ServerValue.TIMESTAMP,
      };

      let { score } = triviaState;
      score += earnedPoints;

      const updates = {
        [`/devices/${deviceID}/score`]: score,
        [`/answers/${triviaId}/${deviceID}`]: payload,
      };

      if (authenticatedUserId) {
        updates[`/scores/${authenticatedUserId}`] = score;
      }
      await db.ref().update(updates);

      await dispatch({ type: SELECT_CHOICE, payload: { triviaId, ...payload } });
    } else {
      throw new Error('Trivia question does not exists');
    }
  } catch (err) {
    await dispatch({ type: SELECT_CHOICE, payload: err, error: true });
  } finally {
    disconnectDb();
  }
};
